import { cn } from "~/lib/utils";

// Sized relative to the base (whole-dollar) font size.
const SYMBOL_SIZE = "text-[0.6em]";
const CENTS_SIZE = "text-[0.5em]";
const CURRENCY_SIZE = "text-[0.25em]";

export interface PriceDisplayProps {
  value: number;
  currencySymbol: string;
  currencyCode?: string;
  /** Base size in px — everything else is sized relative to this via `em`. */
  fontSize: number;
  weightClassName: string;
  className?: string;
}

// Manual layout instead of Figma's `font-feature-settings: "numr"` — that OpenType
// feature needs Helvetica Now Display, which isn't loaded here (falls back to
// Helvetica Neue/Arial).
export function PriceDisplay({ value, currencySymbol, currencyCode, fontSize, weightClassName, className }: PriceDisplayProps) {
  const [whole, cents] = value.toFixed(2).split(".");
  return (
    // Unitless leading-[0.7] set once here so it recomputes per descendant's own font-size.
    <div className={cn("flex gap-[0.07em] leading-[0.7]", className)} style={{ fontSize }}>
      <span className={cn(SYMBOL_SIZE, weightClassName, "font-display self-start")}>{currencySymbol}</span>
      <span className={cn(weightClassName, "font-display")}>{whole}</span>
      <div className="flex flex-col justify-between">
        <span className={cn(CENTS_SIZE, weightClassName, "font-display")}>{cents}</span>
        {/* font-sans, not font-display — Helvetica Now Display has no Regular (400) cut
            loaded in this project (only Bold/XBold), so 400 here would fall back to Bold. */}
        {currencyCode && <span className={cn(CURRENCY_SIZE, "font-sans")}>{currencyCode}</span>}
      </div>
    </div>
  );
}
